import { render } from "./PublicDashboardItem.vue?vue&type=template&id=574616d8&scoped=true"
import script from "./PublicDashboardItem.vue?vue&type=script&lang=js"
export * from "./PublicDashboardItem.vue?vue&type=script&lang=js"

import "./PublicDashboardItem.vue?vue&type=style&index=0&id=574616d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574616d8"]])

export default __exports__